<template>
  <div class="space-y-4">
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">Full Name</label>
      <input
        v-model="localSection.data.fullName"
        type="text"
        class="form-input w-full"
        placeholder="John Doe"
      />
    </div>
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">Title</label>
      <input
        v-model="localSection.data.title"
        type="text"
        class="form-input w-full"
        placeholder="Software Engineer"
      />
    </div>
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">Email</label>
      <input
        v-model="localSection.data.email"
        type="email"
        class="form-input w-full"
        placeholder="john@example.com"
      />
    </div>
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">Phone</label>
      <input
        v-model="localSection.data.phone"
        type="tel"
        class="form-input w-full"
        placeholder="+1 (555) 123-4567"
      />
    </div>
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">Location</label>
      <input
        v-model="localSection.data.location"
        type="text"
        class="form-input w-full"
        placeholder="City, Country"
      />
    </div>
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">Summary</label>
      <textarea
        v-model="localSection.data.summary"
        class="form-input w-full"
        rows="4"
        placeholder="Brief professional summary..."
      ></textarea>
    </div>
    <button
      @click="save"
      class="w-full px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
    >
      Save Section
    </button>
  </div>
</template>

<script>
export default {
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      localSection: JSON.parse(JSON.stringify(this.section))
    }
  },
  methods: {
    save() {
      this.$emit('update', this.localSection)
    }
  }
}
</script>

